<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    :title="$t('public.add')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="self-dialog-form"
    width="50%"
    append-to-body
  >
    <el-form
      ref="baseFromRef"
      :model="formData"
      label-position="top"
      :rules="formRules"
      :disabled="status === 'view'"
    >
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item
            :label="$t('parameterTemplate.paramsCode')"
            label-width="120px"
            class="padding-right25"
            prop="configKey"
          >
            <el-input
              v-model="formData.configKey"
              :disabled="configKeyDisabled"
              :placeholder="$t('public.pleaseEnter')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('parameterTemplate.paramsName')"
            label-width="120px"
            class="padding-right25"
            prop="configName"
          >
            <el-input
              v-model="formData.configName"
              :placeholder="$t('public.pleaseEnter')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$t('parameterTemplate.paramsType')"
            label-width="120px"
            prop="configType"
          >
            <el-select
              v-model="formData.configType"
              :placeholder="$t('public.pleaseSelect')"
              @change="configTypeOnChange"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('excelConfiguration.defaultValue')"
            label-width="120px"
            prop="defaultValue"
          >
            <el-input
              v-model="formData.defaultValue"
              :placeholder="$t('public.pleaseEnter')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="[0, 2, 3].includes(formData.configType)" :gutter="20">
        <el-button
          v-if="[2, 3].includes(formData.configType)"
          class="float-right"
          icon="el-icon-circle-plus-outline"
          type="primary"
          @click="addRowData()"
        >
          {{ $t("public.add") }}
        </el-button>
        <EdmCustomTable
          ref="customTable"
          :show-pagination="false"
          :table-data="formData.selectContents"
          row-key="columnName"
        >
          <el-table-column width="200" :min-width="200" :label="$t('parameterTemplate.displayValue')">
            <template slot-scope="scope">
              <!-- 编辑态 -->
              <el-form-item
                v-if="status !== 'view'"
                :prop="`selectContents[${scope.$index}].displayValue`"
                :rules="formRules.displayValue"
              >
                <el-input
                  v-model="scope.row.displayValue"
                  :placeholder="$t('public.pleaseEnter')"
                  :disabled="formData.configType === '0'"
                  autocomplete="off"
                />
              </el-form-item>
              <!-- 查看态 -->
              <template v-else>
                <span>{{ scope.row.displayValue }}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column :width="'auto'" :min-width="200" :label="$t('parameterTemplate.selectValue')">
            <template slot-scope="scope">
              <!-- 编辑态 -->
              <el-form-item
                v-if="status !== 'view'"
                :prop="`selectContents[${scope.$index}].selectValue`"
                :rules="formRules.selectValue"
              >
                <el-input
                  v-model="scope.row.selectValue"
                  :placeholder="$t('public.pleaseEnter')"
                  autocomplete="off"
                />
              </el-form-item>
              <!-- 查看态 -->
              <template v-else>
                <span>{{ scope.row.selectValue }}</span>
              </template>
            </template>
          </el-table-column>

          <el-table-column
            v-if="status !== 'view'"
            fixed="right"
            :label="$t('public.operation')"
            :min-width="130"
            width="130"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                class="btn__text--no-padding btn__text--red"
                :disabled="formData.configType === '0'"
                @click="deleteRowData(scope.$index)"
              >
                {{ $t("public.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </EdmCustomTable>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t("public.confirm") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ParameterAdd",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    propData: {
      type: Object,
      default() {
        return {};
      },
    },
    status: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formKey: new Date().getTime(),
      typeOptions: [
        { dictLabel: this.$t("parameterTemplate.stringType"), dictValue: "1-1" },
        { dictLabel: this.$t("parameterTemplate.numberType"), dictValue: "1-0" },
        { dictLabel: this.$t("parameterTemplate.switchType"), dictValue: 0 },
        { dictLabel: this.$t("parameterTemplate.singleType"), dictValue: 2 },
        { dictLabel: this.$t("parameterTemplate.multipleType"), dictValue: 3 },
      ],
      formData: {
        selectContents: [],
      },
      formRules: {
        configKey: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}${this.$t("parameterTemplate.paramsCode")}`,
            trigger: "blur",
          },
        ],
        configName: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}${this.$t("parameterTemplate.paramsName")}`,
            trigger: "blur",
          },
        ],
        configType: [
          {
            required: true,
            message: `${this.$t("public.pleaseSelect")}${this.$t("parameterTemplate.paramsType")}`,
            trigger: "change",
          },
        ],
        defaultValue: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}${this.$t("excelConfiguration.defaultValue")}`,
            trigger: "blur",
          },
        ],
        selectValue: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}${this.$t("parameterTemplate.selectValue")}`,
            trigger: "blur",
          },
        ],
        displayValue: [
          {
            required: true,
            message: `${this.$t("public.pleaseEnter")}${this.$t("parameterTemplate.displayValue")}`,
            trigger: "blur",
          },
        ],
      },
      configKeyDisabled: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  created() {
    if (this.propData && this.propData.configKey) {
      this.configKeyDisabled = true;
      this.$set(this, "formData", this.propData);
    }
  },
  methods: {
    configTypeOnChange(val) {
      const option = this.typeOptions.find((o) => o.dictValue === val);
      this.$set(this.formData, "configTypeName", option ? option.dictLabel : "");
      if (val === 0) {
        const selectContents = [
          { selectValue: "", displayValue: "true" },
          { selectValue: "", displayValue: "false" },
        ];
        this.$set(this.formData, "selectContents", selectContents);
      } else {
        this.$set(this.formData, "selectContents", []);
      }
    },
    addRowData() {
      this.formData.selectContents.push({
        selectValue: "",
        displayValue: "",
      });
    },
    deleteRowData(index) {
      this.formData.selectContents.splice(index, 1);
    },
    onConfirm() {
      this.$refs.baseFromRef.validate((valid) => {
        if (valid) {
          // 如果参数类型为开关、单选、多选时，判断参数键值是否存在
          if ([0, 2, 3].includes(this.formData.configType)) {
            if (this.formData.selectContents.length === 0) {
              this.$message.warning(`${this.$t("public.pleaseEnter")}${this.$t("parameterTemplate.paramsKeyValue")}`);
              return;
            }
            // 如果参数类型为开关、单选、多选时，判断默认值是否为参数项中的值
            if (
              !this.formData.selectContents.some(
                (item) => item.selectValue === this.formData.defaultValue
              )
            ) {
              this.$message.warning(this.$t("parameterTemplate.defaultValueNoExist"));
              return;
            }
          }
          this.dialogVisible = false;
          this.$emit("confirm", this.formData, this.status);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
